import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";


interface Props {
  onTapCloseModal: () => void;
}

// ログイン画面で利用している「パスワードを忘れた方、お困りの方はこちら」モーダル
export const MailSendModal = ({ onTapCloseModal }: Props) => {

  return (
    <BasePageModal
      title="メール送信完了"
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="閉じる"
          onClick={onTapCloseModal}
        />
      }
    >
      <div className="mail_send_modal__content">
        <p className="mail_send_modal__text">
          メールサーバー上で自動的に、迷惑メールなどの通常使用しているフォルダ以外に送信される場合がありますのでご注意ください。

          URL付きメールが受信拒否になっている場合や、ドメイン指定などでの受信設定の影響で届かない場合があります。

          「@mail.sorimachi.co.jp」のドメインを受信できるよう設定ください。
        </p>
      </div>
    </BasePageModal>
  );
};
